/**
 * Convert between an ISO 8601 date-time and the local date / time parts the pickers edit
 * (`YYYY-MM-DD`, `HH:MM` 24h). A value with `Z` or an offset is shown in the user's local time; a
 * value without one is taken as already local. Writing back always includes the local UTC offset, so
 * the backend never has to guess the timezone (e.g. `2026-10-16T10:00:00+05:30`).
 */
const pad = (n: number) => String(n).padStart(2, '0');

export function isoToLocalParts(value: string | null | undefined): { date: string; time: string } {
  if (!value) return { date: '', time: '' };
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return { date: '', time: '' };
  return {
    date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
    time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
  };
}

export function localPartsToIso(date: string, time: string): string {
  if (!date) return '';
  const t = time || '09:00';
  const local = new Date(`${date}T${t}:00`);
  if (Number.isNaN(local.getTime())) return '';
  const off = -local.getTimezoneOffset();
  const sign = off >= 0 ? '+' : '-';
  const abs = Math.abs(off);
  return `${date}T${t}:00${sign}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
}
